/**
 * @generated SignedSource<<0223540f7abdf83c6bb0c85d738fc980>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemPickerLabelsItem_PathFragment$data = {
  readonly resourcePath: string;
  readonly url: string;
  readonly " $fragmentType": "ItemPickerLabelsItem_PathFragment";
};
export type ItemPickerLabelsItem_PathFragment$key = {
  readonly " $data"?: ItemPickerLabelsItem_PathFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemPickerLabelsItem_PathFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ItemPickerLabelsItem_PathFragment"
};

(node as any).hash = "442ccfb0820f089b5595186730643987";

export default node;
